/**
 * Mirror of the backend `CheqMe.Contracts.Core.Booking.BookingType` enum. Append-only — the numeric values are
 * persisted and transmitted, so members must never be renumbered or removed.
 */
export enum BookingType {
  Cash,
  Card,
  Employee,
  BookingItem,
  BookingEnd,
  /** No payment moved — money-neutral for the till (e.g. a Forderung/receivable, #203). */
  None
}

export const BookingTypeLabels: { [key: number]: string } = {
  [BookingType.Cash]: "Bar",
  [BookingType.Card]: "Karte",
  [BookingType.Employee]: "Mitarbeiter",
  [BookingType.BookingItem]: "Buchung",
  [BookingType.BookingEnd]: "Buchung",
  [BookingType.None]: "Keine"
};
